module.exports = __webpack_public_path__ + "img/logo.68985f7c.jpg";